import get from 'lodash/get';
import { isAppModule, ROUTE_CUSTOM_DASHBOARD, DASHBOARD_TYPE } from './constants';
import getBaseUrl from './getBaseUrl';

const baseUrl = getBaseUrl(ROUTE_CUSTOM_DASHBOARD);
const parseDashboardURL = (dashboardItem: any = {}) => {
  let url = `${baseUrl}/trends`;
  if (isAppModule) {
    url = `${baseUrl}/app-experience`;
  }

  if (dashboardItem.dashboardTypeId) {
    url = `${baseUrl}/`;
    switch (dashboardItem.dashboardTypeId) {
      case DASHBOARD_TYPE.COMPARE:
        url += `compare/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.ERROR_DIAGNOSTICS:
        url += `error-diagnostics/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.TIMELINE:
        url += `timeline/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.NOC:
        url += `noc/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.OVB:
        url += `overview/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.ML:
        url += `metriclens/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.AI_ROADMAP:
        url += `ai-roadmap/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.VIEWER_MODULE:
        url += `viewer-module/saved/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.TRENDS:
        url += `trends/saved/${dashboardItem.id}`;
        break;

      case DASHBOARD_TYPE.APP_EXPERIENCE:
        url += `app-experience/saved/${dashboardItem.id}`;
        break;

      default:
        url += 'trends';
    }
  }

  return url;
};

export default parseDashboardURL;
